{
  "manager": {
    "userList": {
      "addUser": "Add User",
      "memberId": "Member ID",
      "userAddedSuccess": "User added successfully",
      "userAddFailed": "Failed to add user",
      "userRemovedSuccess": "User removed successfully",
      "userRemoveFailed": "Failed to remove user",
      "userLoadFailed": "Failed to load users"
    }
  }
}
